// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

// Lib
import { updateData, checkAllCheckbox, priceAvailable } from 'lib/prices';
import { convertDataByKey, filteredDBData, getClearedArrayDublicate, sortedArray } from 'lib/thesaurus';

// Type
import { Supplier } from 'pages/MoleculeProduct/reducer';
import { TPrice } from 'components/Carts/CartBio/CartBio';

// Actions
import * as actionsCreatorThesaurus from 'pages/Thesaurus/reducer';

// Type
export type TGenes = {
	url?: string,
	name?: string,
};
export type TChildren = {
	lvl: number
	name: string
	type: string
	navKey: string
	groupId: number
	familyId: number
	className: string
	matchSearch: boolean
	children: TChildren[],
};
export type TSelectors = {
	label?: string,
	value?: string | number,
};
export type TAvailability = {
	label?: string,
	value?: string,
}
export type TBaData = {
	id?: string,
	px?: string[],
	tarPx?: string,
	isPOA: boolean,
	onStock?: boolean,
	supIds?: Supplier[],
	currentTypePrice: string,
	prices: {
		supplier?: string;
		prices?: TPrice[];
	}[],
	tarRefs?: string,
	tarAction?: string,
	selected?: boolean,
	currentPrice?: any,
};
export type TUpdateData = {
	id?: string,
	key?: string,
	data?: TBaData[],
	value?: string | number | boolean,
};
export type TDataTargetDetails = {
	name?: string,
	genes?: TGenes[],
	synonyms?: string[],
};

// Interface
interface IInitialState {
	tags: [],
	px?: string,
	type: string,
	input: string,
	goTo?: number,
	typeTab?: string,
	message: string,
	isNoData?: boolean,
	data: TChildren[],
	toggleTargetDetails: boolean,

	structureData: {
		drugs: {
			checkboxAll?: boolean;

			goTo: number,
			paged?: boolean;
			pageSize: number,
			currPage: number,
			content: TChildren[],
			baseBaData: TChildren[];

			tarPx?: string,
			tarAction?: TSelectors,
			optionsTarPx?: TSelectors[],
			availability?: TAvailability,
			optionsTarAction?: TSelectors[],
			optionsAvailability?: TSelectors[],
		};
		impurities: {
			checkboxAll?: boolean;

			goTo: number,
			paged?: boolean;
			pageSize: number,
			currPage: number,
			content: TChildren[],
			baseBaData: TChildren[];

			tarPx?: string,
			tarAction?: TSelectors,
			optionsTarPx?: TSelectors[],
			availability?: TAvailability,
			optionsTarAction?: TSelectors[],
			optionsAvailability?: TSelectors[],
		},
		chemicalProbes: {
			checkboxAll?: boolean;

			goTo: number,
			paged?: boolean;
			pageSize: number,
			currPage: number,
			content: TChildren[],
			baseBaData: TChildren[];

			tarPx?: string,
			tarAction?: TSelectors,
			optionsTarPx?: TSelectors[],
			availability?: TAvailability,
			optionsTarAction?: TSelectors[],
			optionsAvailability?: TSelectors[],
		},
		compounds: {
			checkboxAll?: boolean;

			paged: boolean;
			goTo: number;
			pageSize: number;
			currPage: number;
			content: TChildren[];
			baseBaData: TChildren[];

			tarPx?: string,
			tarAction?: TSelectors,
			optionsTarPx?: TSelectors[],
			availability?: TAvailability,
			optionsTarAction?: TSelectors[],
			optionsAvailability?: TSelectors[],
		},
	}

	loading: boolean,
	resultGTF: string[],
	autoExpand?: boolean,
	showAllData?: boolean,
	loadingBaData: boolean,
	isInitLoading?: boolean,
	loadingSearchBio: boolean,
	BAData: TBaData[],
	baseBaData: TBaData[],
	loadingTargetDetails: boolean,
	dataTargetDetails: TDataTargetDetails,

	expand: string[];
}

type TUpdateSelectData = {
	data: TBaData[],
	selected: boolean,
}

type TIteratingOverArray = {
	key?: string,
	value?: any,
	data?: TBaData[],
}

export const initialStateSelectors = {
	value: '',
	label: 'All'
};

const initialStateStructureData = {
	checkboxAll: false,

	goTo: 1,
	paged: true,
	currPage: 0,
	content: [],
	pageSize: 20,
	baseBaData: [],

	tarPx: '4.5',
	optionsTarPx: [],
	optionsTarAction: [],
	optionsAvailability: [],
	tarAction: initialStateSelectors,
	availability: initialStateSelectors
};

const initialState: IInitialState = {
	tags: [],
	type: '',
	input: '',
	px: '4.5',
	message: '',
	resultGTF: [],
	loading: false,
	isNoData: false,
	checkboxAll: false,
	isInitLoading: false,
	loadingBaData: false,
	dataTargetDetails: {},
	loadingSearchBio: false,
	toggleTargetDetails: false,
	loadingTargetDetails: false,

	autoExpand: false,
	showAllData: false,

	data: [],
	BAData: [],
	baseBaData: [],

	structureData: {
		drugs: initialStateStructureData,
		compounds: initialStateStructureData,
		impurities: initialStateStructureData,
		chemicalProbes: initialStateStructureData
	},

	typeTab: 'compounds',

	expand: [],
};

const updateSelectData = ({ data, selected }: TUpdateSelectData) => data.length ? data?.map((item: TBaData) => {
	const canSelect = !item.isPOA &&
		item.onStock &&
		priceAvailable(item)?.available;

	return {
		...item,
		selected: selected && canSelect,
	};
}) : [];

const iteratingOverArrayByKey = (opt: TIteratingOverArray) => {
	const { key, data, value } = opt;
	return data?.length ? data?.map((item: TBaData) => ({
		...item,
		[key as string]: value
	})) : [];
};

export const filterByKey = ({ data = [], key = 'drug' }: { data: TBaData[], key: string }) => {
	// @ts-ignore
	return data?.length ? data.filter((item: TBaData) => item[key]) : [];
};

export const thesaurusSlice = createSlice({
	name: 'thesaurus',
	initialState,
	reducers: {
		handleExpand: (state, action) => {
			state.expand = action.payload;
		},

		toggleTargetDetails: (state) => {
			state.toggleTargetDetails = !state.toggleTargetDetails;
		},

		handlerChangeCurrentTypePrice: (state, action) => {
			const id = action.payload.id;
			const type = action.payload.type;

			const data = updateData({
				id: id,
				value: type,
				key: 'currentTypePrice',
				data: state?.structureData[state?.typeTab].content?.length ? state?.structureData[state?.typeTab].content : []
			}) || [];

			const baseData = updateData({
				id: id,
				value: type,
				key: 'currentTypePrice',
				data: state?.structureData[state?.typeTab].baseBaData?.length ? state?.structureData[state?.typeTab].baseBaData : []
			}) || [];

			state.structureData[state?.typeTab].content = data;
			state.structureData[state?.typeTab].baseBaData = baseData;
		},

		handlerChangeSize: (state, action) => {
			state.structureData[state?.typeTab].pageSize = action.payload;
		},
		handlerChangeTab: (state, action) => {
			state.typeTab = action.payload;
		},

		handlerClearBAData: (state) => {
			state.structureData[state?.typeTab].content = [];
			state.structureData[state?.typeTab].baseBaData = [];
		},
		handlerChangeShowAllData: (state) => {
			state.showAllData = !state.showAllData;
		},
		handlerChangeAutoExpand: (state, action) => {
			state.autoExpand = action.payload;
		},

		handlerChangeAllPrices: (state, action) => {
			const prepackage = action.payload;

			state.structureData[state?.typeTab].content = state?.structureData[state?.typeTab].content?.length
				? state?.structureData[state?.typeTab].content?.map((item: any) => {
					const updatedItem = { ...item, currentPrice: prepackage };
					const canSelect =
						!updatedItem.isPOA &&
						updatedItem.onStock &&
						priceAvailable(updatedItem)?.available;

					return {
						...updatedItem,
						selected: state.structureData[state?.typeTab].checkboxAll && canSelect
					};
				})
				: [];
		},

		handlerChangeClearSelected: (state) => {
			state.structureData[state?.typeTab].checkboxAll = false;
			state.structureData[state?.typeTab].content = iteratingOverArrayByKey({
				value: false,
				key: 'selected',
				data: state.structureData[state?.typeTab].content
			});
			state.structureData[state?.typeTab].baseBaData = iteratingOverArrayByKey({
				value: false,
				key: 'selected',
				data: state.structureData[state?.typeTab].baseBaData
			});

		},
		handlerChangeSortItems: (state, action) => {
			let result: any = [];
			const key = action.payload.key;
			const typeSort = action.payload.typeSort;

			if (
				key === 'px' &&
				typeSort === 'sortMax'
			) {
				// @ts-ignore
				result = state.structureData[state?.typeTab].content.sort((a: TBaData, b: TBaData) => b[key] - a[key]);
			}

			if (
				key === 'px' &&
				typeSort === 'sortMin'
			) {
				// @ts-ignore
				result = state.structureData[state?.typeTab].content.sort((a: TBaData, b: TBaData) => a[key] - b[key]);
			}

			if (
				key !== 'px' &&
				typeSort === 'sortMax'
			) {
				// @ts-ignore
				result = state.structureData[state?.typeTab].content.sort((a: TBaData, b: TBaData) => a[key].localeCompare(b[key]));
			}

			if (
				key !== 'px' &&
				typeSort === 'sortMin'
			) {
				// @ts-ignore
				result = state.structureData[state?.typeTab].content.slice().sort((a: TBaData, b: TBaData) => b[key].localeCompare(a[key]));
			}

			state.structureData[state?.typeTab].content = result;
		},
		handlerChangeTarPx: (state, action) => {
			state.structureData[state?.typeTab].tarPx = action.payload;

			// Data
			const baseBaData = state.structureData[state?.typeTab].baseBaData;

			// Filter params
			const tarPx = action.payload;
			const tarAction = state.structureData[state?.typeTab].tarAction?.value;
			const availability = state.structureData[state?.typeTab]?.availability?.value;

			const filterFunction = filteredDBData({
				tarPx: tarPx,
				tarAction: tarAction as string,
				availability: availability as string
			});

			const filteredArray = baseBaData.filter(filterFunction);

			const optionsTarPx: TSelectors[] = convertDataByKey(filteredArray, 'tarAction');

			const filteredOptionsDublicateTarPx = sortedArray({
				data: getClearedArrayDublicate(optionsTarPx, 'value')
			});

			filteredOptionsDublicateTarPx.unshift(actionsCreatorThesaurus.initialStateSelectors);

			state.structureData[state?.typeTab].currPage = 0;
			state.structureData[state?.typeTab].checkboxAll = false;
			state.structureData[state?.typeTab].content = iteratingOverArrayByKey({
				value: false,
				key: 'selected',
				data: filteredArray
			});
			state.structureData[state?.typeTab].optionsTarAction = filteredOptionsDublicateTarPx;
		},
		handlerChangeTarAction: (state, action) => {
			state.structureData[state?.typeTab].tarAction = action.payload;

			// Data
			const dataOld = state.structureData[state?.typeTab].baseBaData;

			// Filter params
			const tarPx = state?.structureData[state?.typeTab]?.tarPx;
			const tarAction = action.payload?.value;
			const availability = state?.structureData[state?.typeTab].availability?.value;

			const filterFunction = filteredDBData({
				tarPx: tarPx,
				tarAction: tarAction as string,
				availability: availability as string
			});

			state.structureData[state?.typeTab].currPage = 0;
			state.structureData[state?.typeTab].checkboxAll = false;
			state.structureData[state?.typeTab].content = iteratingOverArrayByKey({
				value: false,
				key: 'selected',
				data: dataOld.filter(filterFunction)
			});
		},
		handlerChangeAvailability: (state, action) => {
			state.structureData[state?.typeTab].availability = action.payload;

			// Data
			const dataOld = state.structureData[state?.typeTab].baseBaData;

			// Filter params
			const tarPx = state?.structureData[state?.typeTab].tarPx;
			const tarAction = state?.structureData[state?.typeTab].tarAction?.value;
			const availability = action.payload.value;

			const filterFunction = filteredDBData({
				tarPx: tarPx,
				tarAction: tarAction as string,
				availability: availability as string
			});

			state.structureData[state?.typeTab].currPage = 0;
			state.structureData[state?.typeTab].checkboxAll = false;
			state.structureData[state?.typeTab].content = iteratingOverArrayByKey({
				value: false,
				key: 'selected',
				data: dataOld.filter(filterFunction)
			});
		},
		handlerChangeCurrPage: (state, action) => {
			state.structureData[state?.typeTab].currPage = action.payload;
		},
		handlerChangeUpdateCurrPage: (state, action) => {
			state.structureData[state?.typeTab].goTo = action.payload;
		},

		handlerChangeCheckboxAll: (state, action) => {
			const selected = action.payload;

			state.structureData[state?.typeTab].checkboxAll = selected;

			state.structureData[state?.typeTab].content = updateSelectData({
				data: state.structureData[state?.typeTab].content,
				selected: selected
			});
			state.structureData[state?.typeTab].baseBaData = updateSelectData({
				selected: selected,
				data: state.structureData[state?.typeTab].baseBaData
			});
		},
		handlerChangeCheckboxItem: (state, action) => {
			const id = action.payload.id;
			const selected = action.payload.selected;

			const data = updateData({
				id: id,
				key: 'selected',
				value: selected,
				data: state?.structureData[state?.typeTab].content?.length ? state?.structureData[state?.typeTab].content : []
			}) || [];

			const baseData = updateData({
				id: id,
				key: 'selected',
				value: selected,
				data: state?.structureData[state?.typeTab].baseBaData?.length ? state?.structureData[state?.typeTab].baseBaData : []
			}) || [];

			state.structureData[state?.typeTab].checkboxAll = checkAllCheckbox(data);
			state.structureData[state?.typeTab].content = data;
			state.structureData[state?.typeTab].baseBaData = baseData;
		},
		handlerChangeQuantityItem: (state, action) => {
			const id = action.payload.id;
			const number = action.payload.number;

			state.structureData[state?.typeTab].content = updateData({
				id: id,
				value: number,
				key: 'quantity',
				data: state?.structureData[state?.typeTab].content?.length ? state?.structureData[state?.typeTab].content : []
			}) || [];
		},
		handlerChangePriceItem: (state, action) => {
			const id = action.payload.id;
			const price = action.payload.price;

			state.structureData[state?.typeTab].content = updateData({
				id: id,
				value: price,
				key: 'currentPrice',
				data: state?.structureData[state?.typeTab].content?.length ? state?.structureData[state?.typeTab].content : []
			}) || [];
		},

		handlerChangeInputPx: (state, action) => {
			state.px = action.payload;
		},

		handlerChangeNoData: (state, action) => {
			state.isNoData = action.payload;
		},

		getBaDataForTargets: (state) => {
			state.isNoData = false;
			state.structureData[state?.typeTab].checkboxAll = false;
			state.loadingBaData = true;

			state.structureData[state?.typeTab].goTo = 1;
			state.structureData[state?.typeTab].currPage = 0;
			state.structureData[state?.typeTab].tarPx = state.px;
			state.structureData[state?.typeTab].tarAction = initialStateSelectors;
			state.structureData[state?.typeTab].availability = initialStateSelectors;
		},
		getBaDataForTargetsError: (state) => {
			state.loadingBaData = false;
		},
		getBaDataForTargetsSuccess: (state, action) => {
			state.loadingBaData = false;

			state.structureData.drugs.content = action.payload.drugs;
			state.structureData.compounds.content = action.payload.compounds;
			state.structureData.impurities.content = action.payload.impurities;
			state.structureData.chemicalProbes.content = action.payload.chemicalProbes;

			state.structureData.drugs.baseBaData = action.payload.drugs;
			state.structureData.impurities.baseBaData = action.payload.impurities;
			state.structureData.compounds.baseBaData = action.payload.compounds;
			state.structureData.chemicalProbes.baseBaData = action.payload.chemicalProbes;

			state.structureData.drugs.optionsTarPx = action.payload.optionsTarPxDrugs;
			state.structureData.drugs.optionsTarAction = action.payload.optionsTarActionDrugs;
			state.structureData.drugs.optionsAvailability = action.payload.optionsAvailabilityDrugs;

			state.structureData.compounds.optionsTarPx = action.payload.optionsTarPxCompounds;
			state.structureData.compounds.optionsTarAction = action.payload.optionsTarActionCompounds;
			state.structureData.compounds.optionsAvailability = action.payload.optionsAvailabilityCompounds;

			state.structureData.impurities.optionsTarPx = action.payload.optionsTarPxImpurities;
			state.structureData.impurities.optionsTarAction = action.payload.optionsTarActionImpurities;
			state.structureData.impurities.optionsAvailability = action.payload.optionsAvailabilityImpurities;

			state.structureData.chemicalProbes.optionsTarPx = action.payload.optionsTarPxChemicalProbes;
			state.structureData.chemicalProbes.optionsTarAction = action.payload.optionsTarActionChemicalProbes;
			state.structureData.chemicalProbes.optionsAvailability = action.payload.optionsAvailabilityChemicalProbes;
		},

		getTargetDetailsById: (state, action) => {
			state.loadingTargetDetails = true;
		},
		getTargetDetailsByIdError: (state) => {
			state.loadingTargetDetails = false;
		},
		getTargetDetailsByIdSuccess: (state, action) => {
			state.loadingTargetDetails = false;
			state.dataTargetDetails = action.payload;
		},

		getThesaurusById: (state, action) => {
			const isInit = action.payload;

			state.loading = true;
			if (isInit) {
				state.isInitLoading = true;
			}
		},
		getThesaurusByIdError: (state) => {
			state.loading = false;
			state.isInitLoading = false;
		},
		getThesaurusByIdSuccess: (state, action) => {
			state.loading = false;
			state.isInitLoading = false;
			state.data = action.payload;
		},

		searchTextBio: (state, action) => {
			state.loadingSearchBio = true;
		},
		searchTextBioError: (state, action) => {
			state.loadingSearchBio = false;
			state.type = action.payload.type;
			state.message = action.payload.message;
		},
		searchTextBioSuccess: (state, action) => {
			state.data = action.payload;
			state.loadingSearchBio = false;
		},
		handlerChangeMessage: (state, action) => {
			state.type = action.payload.type;
			state.message = action.payload.message;
		},

		handlerChangeInput: (state, action) => {
			state.input = action.payload;
		},

		handlerChangeCheckedGtf: (state, action) => {
			state.resultGTF = action.payload;
		},

		handlerUpdateTags: (state, action) => {
			state.tags = action.payload;
		}
	}
});

export const {
	handleExpand,
	toggleTargetDetails,

	handlerChangeCurrentTypePrice,

	handlerChangeSize,

	handlerChangeTab,

	handlerClearBAData,
	handlerChangeNoData,

	handlerChangeShowAllData,
	handlerChangeAutoExpand,

	handlerChangeMessage,

	getThesaurusById,
	getThesaurusByIdError,
	getThesaurusByIdSuccess,

	searchTextBio,
	searchTextBioError,
	searchTextBioSuccess,

	getTargetDetailsById,
	getTargetDetailsByIdError,
	getTargetDetailsByIdSuccess,

	getBaDataForTargets,
	getBaDataForTargetsError,
	getBaDataForTargetsSuccess,


	handlerChangeTarPx,
	handlerChangeCurrPage,
	handlerChangeSortItems,
	handlerChangeTarAction,
	handlerChangeAvailability,
	handlerChangeClearSelected,
	handlerChangeUpdateCurrPage,

	handlerUpdateTags,
	handlerChangeInput,
	handlerChangeInputPx,
	handlerChangePriceItem,
	handlerChangeCheckedGtf,
	handlerChangeCheckboxAll,
	handlerChangeQuantityItem,
	handlerChangeCheckboxItem,

	handlerChangeAllPrices
} = thesaurusSlice.actions;

export default thesaurusSlice.reducer;
